/* @flow */

// eslint-disable-next-line import/no-namespace
import * as INTERFACE from './interface';

export * from './interface';
export default INTERFACE;
